import { useState } from "react";
import { Link } from "react-router-dom";
import { Download, Menu, X, User, MessageSquare } from "lucide-react";

export default function Header({ apiUrl, onDownload }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "Features", href: "#features" },
    { label: "Pricing", href: "#pricing" },
    { label: "Preview", href: "#preview" },
    { label: "Docs", href: "#docs" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      data-testid="header-nav"
      className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-[#E4E4E7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <a href="#" className="flex items-center gap-2.5 no-underline" data-testid="header-logo">
          <div className="w-8 h-8 rounded-md bg-[#FF7300] flex items-center justify-center">
            <span className="text-white font-display font-bold text-sm">A</span>
          </div>
          <span className="font-display font-bold text-[#09090B] text-base tracking-tight hidden sm:inline">
            AmznAWP
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-[#52525B] hover:text-[#09090B] transition-colors no-underline"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/portal"
            data-testid="header-portal-link"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-[#52525B] hover:text-[#09090B] transition-colors no-underline"
          >
            <User size={14} />
            My Account
          </Link>
          <Link
            to="/contact"
            data-testid="header-contact-link"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-[#52525B] hover:text-[#09090B] transition-colors no-underline"
          >
            <MessageSquare size={14} />
            Contact
          </Link>
          <button
            data-testid="header-download-btn"
            onClick={onDownload}
            className="hidden sm:flex items-center gap-2 bg-[#09090B] text-white hover:bg-[#FF7300] transition-all rounded-md px-5 py-2 text-sm font-semibold cursor-pointer border-0"
          >
            <Download size={14} />
            Download ZIP
          </button>

          <button
            data-testid="mobile-menu-btn"
            className="md:hidden p-2 rounded-md hover:bg-[#F9FAFB] transition-colors border-0 bg-transparent cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-[#E4E4E7] animate-fade-in">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-[#52525B] hover:text-[#09090B] py-2 no-underline"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={onDownload}
              className="mt-2 flex items-center justify-center gap-2 bg-[#FF7300] text-white rounded-md px-5 py-2.5 text-sm font-semibold border-0 cursor-pointer"
            >
              <Download size={14} />
              Download ZIP
            </button>
            <Link
              to="/portal"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 text-sm font-medium text-[#52525B] hover:text-[#09090B] py-2 no-underline"
            >
              <User size={14} /> My Account
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 text-sm font-medium text-[#52525B] hover:text-[#09090B] py-2 no-underline"
            >
              <MessageSquare size={14} /> Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
